import ScopeGapCategory from '@/models/ScopeGapCategory';
import ScopeGapCategoryService from '@/services/ScopeGapCategoryService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useScopeGapCategoriesStore = defineStore('scope_gap_categories', {
  state: () => ({}),

  getters: {
    models: () => useRepo(ScopeGapCategory),
  },

  actions: {
    async store(projectId: Id, packageId: Id, request: ApiRequests['api.v1.scope-gap-categories.store']) {
      const [data, error] = await ScopeGapCategoryService.store(projectId, packageId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async update(id: Id, request: ApiRequests['api.v1.scope-gap-categories.update']) {
      const [data, error] = await ScopeGapCategoryService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async destroy(id: Id) {
      const [data, error] = await ScopeGapCategoryService.destroy(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.scope_gap_category.id);

      this.models.save(data.sort_order);

      return data;
    },

    async sort(id: Id, request: ApiRequests['api.v1.scope-gap-categories.sort']) {
      const [data, error] = await ScopeGapCategoryService.sort(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
